import Immutable from 'seamless-immutable';
import * as actionTypes from './actionTypes';

const initialState = Immutable({
  params: {},
  byId: {},
});

export function schoolPsychologyRequestReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_SCHOOL_PSYCHOLOGY_REQUEST:
    case actionTypes.GET_SCHOOL_PSYCHOLOGY_REQUEST_SUCCESS:
    case actionTypes.GET_SCHOOL_PSYCHOLOGY_REQUEST_FAIL:
      return {
        ...state,
        actionsloading: false,
        studentSupportData: action.payload && action.payload.responceObject && action.payload.responceObject.records || {}
      };

    case actionTypes.SAVE_SCHOOL_PSYCHOLOGY_REQUEST_FAIL:
    case actionTypes.SAVE_SCHOOL_PSYCHOLOGY_REQUEST_SUCCESS:
      return {
        ...state,
        actionsloading: false,
      };
    case actionTypes.SAVE_SCHOOL_PSYCHOLOGY_REQUEST:
      return {
        ...state,
        actionsloading: true,
      };
    default:
      return state;
  }
}
